import React from "react";
import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ExtensionEnterpriseSummary({ prefix = "" }) {
  return (
    <section className="mt-10 rounded-[2rem] border border-primary/20 bg-ocean p-5 text-white md:p-8">
      <Building2 className="h-7 w-7 text-cyan-200" />
      <h2 className="mt-3 text-2xl font-black !text-white">Enterprise deployment</h2>
      <p className="mt-2 max-w-3xl leading-7 text-cyan-50/85">Silent or forced extension installation is only available on managed enterprise devices through browser or OS policy.</p>
      <Button asChild className="mt-5 rounded-full bg-white text-ocean hover:bg-cyan-50"><Link to={`${prefix}/extensions/enterprise`}>Deploy Marstick Extension for your organization</Link></Button>
    </section>
  );
}